<template>
    <div class="report-page-template" :class="{ 'has-fda-disclaimer': isFdaUnfriendly }">
        <report-header :report-title="reportTitle" @onReportTitleChange="setNewReportName" />

        <div class="report-page-body">
            <slot></slot>
        </div>

        <report-footer
            :report-title="reportTitle"
            :tenant="tenant"
            :page-num="pageNum"
            :total-pages="totalPages"
        />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ReportHeader from '../../components/report/ReportHeader'
import ReportFooter from '../../components/report/ReportFooter'

export default {
    name: 'ReportPageTemplate',
    components: { ReportHeader, ReportFooter },
    props: {
        reportTitle: {
            type: String,
            required: true
        },
        pageNum: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapState({
            tenant: state => state.common.selectedTenant
        }),
        ...mapGetters({
            isFdaUnfriendly: 'common/isFdaUnfriendly'
        })
    },
    mounted() {
        // zendesk help icon
        zE('webWidget', 'hide')
    },
    methods: {
        setNewReportName(newReportName) {
            this.$emit('onReportTitleChange', newReportName)
        }
    }
}
</script>

<style lang="scss" scoped>
.report-page-template {
    $page-height: 1403px;
    $report-header-height: 68px;

    &.has-fda-disclaimer {
        $report-footer-height: 176px;
        grid-template-rows: #{$report-header-height} auto #{$report-footer-height};
    }
    &:not(.has-fda-disclaimer) {
        $report-footer-height: 123px;
        grid-template-rows: #{$report-header-height} auto #{$report-footer-height};
    }

    position: relative;
    display: grid;
    justify-items: stretch;
    padding: 20px; // to match margin of printer page
    margin: 0 auto 5px;
    border-radius: 3px;
    box-shadow: 0 0 15px #191f26;
    height: #{$page-height};

    @media screen {
        width: 867px; // when using mm the result isn't consistent per screen
        background-color: $dark;
    }
    @media print {
        margin-bottom: 0;
        background: none;
        width: 100%;
        break-inside: avoid-page;
    }

    .report-header {
        margin-bottom: 20px;
    }

    .report-page-body {
        display: flex;
        flex-direction: column;
    }
}
</style>
